<template>
  <div
    class="closing-blockquotes text-body-2"
    v-html="closeBlockquotes(html_string)"
  />
</template>

<script>
import { sanitizeHtml } from "@/utils/sanitizeHtml";

export default {
  name: "ClosingBlockquotes",
  props: ["html_string"],
  methods: {
    closeBlockquotes(data) {
      let el = document.createElement("span");
      // Sanitize the user-authored report HTML before parsing it. The trusted
      // expander button (with its inline onClick) is injected below, after this
      // point, so it is not stripped.
      el.innerHTML = sanitizeHtml(data);

      let button = document.createElement("button");
      button.innerText = "Expand";

      let toggleText = function (param) {
        let el = param.closest("blockquote.tiptap_expander");
        if (el.dataset.current_text == "short_text") {
          el.innerHTML = el.dataset.full_text;
          el.dataset.current_text == "full_text";
        } else {
          el.innerHTML = el.dataset.short_text;
          el.dataset.current_text == "short_text";
        }
      };
      // super ugly string of javascript in the onlcikc of the button
      button.setAttribute(
        "onClick",
        "let bq = this.closest('blockquote.tiptap_expander'); let content = bq.querySelector('div.blockquote_content'); if(content.classList.contains('short_text'))  { content.innerHTML = bq.dataset.full_text; content.classList.remove('short_text') } else { content.innerHTML = bq.dataset.short_text; content.classList.add('short_text') };",
      );
      //button.setAttribute("onClick", "this.closest('blockquote.tiptap_expander').classList.toggle('active')")

      let blockquotes = el.querySelectorAll("blockquote.tiptap_expander");

      for (let i = 0; i < blockquotes.length; i++) {
        // some super ugly code to inject a custom button and a content placeholder
        // in a blockquote that has more than 250 characters
        if (blockquotes[i].innerText.length < 250) continue;
        // create element placeholder
        let placeholder = document.createElement("div");

        // create different versions of the content
        let original_content = blockquotes[i].innerHTML;
        let original_text = blockquotes[i].innerText;
        let original_text_short = original_text.substring(0, 50) + "...";

        // remove the original content from the blockquote
        blockquotes[i].innerHTML = "";

        // add some classes as references, which are leveraged by the button
        placeholder.classList.add("blockquote_content");
        placeholder.classList.add("short_text");

        // put the shortened content in the div placeholder
        placeholder.innerHTML = original_text_short;

        // insert the button and the placeholder
        blockquotes[i].insertAdjacentElement(
          "beforeend",
          button.cloneNode(true),
        );
        blockquotes[i].insertAdjacentElement("beforeend", placeholder);
        blockquotes[i].classList.add("expandable");

        // store both versions of the text in data attributes of the blockquote
        blockquotes[i].dataset.full_text = original_content;
        blockquotes[i].dataset.short_text = original_text_short;
      }
      return el.innerHTML;
    },
  },
};
</script>

<style scoped>
.closing-blockquotes :deep(p) {
  margin: 0.75em 0;
  line-height: 1.5;
}

.closing-blockquotes :deep(blockquote.expandable button) {
  background-color: #fff;
  border: 1px solid #000;
  padding: 2px 4px;
  margin-bottom: 5px;
}
</style>
